import ProductSwitcher from '../product-switcher';
import ThirdPartyLinksHandler from '../shared/third-party-links-handler';
import debounce from '../utils/debounce';
import isMobileBrowser from '../utils/isMobileBrowser';
import GorgiasButtonHandler from '../vendors/gorgias-button';
import SideMenu from './side-menu';
import { HIDDEN } from '../classnames/design-system';
import { PURCHASE_BAR_CLASS } from '../classnames/purchase-bar-anchor';

const DEBOUNCE_DELAY = 50;

export default class PurchaseBar {
  constructor(container) {
    this.buySectionDesktopContainers = [...document.querySelectorAll('[id^="buy-section-"]')];
    this.buySectionMobileContainers = [...document.querySelectorAll('[id^="mobile-buy-section-"]')];
    this.visibleState = false;
    this.container = container;
    this.thirdPartyLinksHandler = new ThirdPartyLinksHandler();
    this.sideMenus = this.buySectionDesktopContainers.map((buySection) => {
      const closeButtonId = `${buySection.id}-close`;
      const showButtonSelector = `.js-${buySection.id}`;
      return new SideMenu(buySection.id, showButtonSelector, closeButtonId);
    });
    this.sideMenusMobile = this.buySectionMobileContainers.map((buySection) => {
      const mobileCloseButtonId = `${buySection.id}-close`;
      const mobileShowButtonSelector = `.js-${buySection.id}`;
      return new SideMenu(buySection.id, mobileShowButtonSelector, mobileCloseButtonId);
    });
    this.ProductSwitcher = new ProductSwitcher();
    this.isMobile = isMobileBrowser();
  }

  handleScrollAndResize = () => {
    const activeProductId = this.ProductSwitcher.getActiveProductId();
    let purchaseBarElements = document.querySelectorAll(`.${PURCHASE_BAR_CLASS}`);

    if (activeProductId) {
      purchaseBarElements = document.querySelectorAll(`.${PURCHASE_BAR_CLASS}[data-product-id="${activeProductId}"]`);
    }

    const gorgiasChatButton = document.getElementById('chat-button');
    const chatWindow = document.getElementById('chat-window');

    if (!purchaseBarElements.length) {
      return;
    }

    // TODO: Refactor this logic using IntersectionObserver API (better performance)
    const containerClientRect = this.container.getBoundingClientRect();
    const scrollY = window.scrollY + containerClientRect.y + containerClientRect.height;
    const visible = window.scrollY > scrollY;

    if (this.visibleState !== visible) {
      if (gorgiasChatButton && !this.isMobile) {
        GorgiasButtonHandler.adjustPositionUp(gorgiasChatButton, chatWindow);
      }

      this.visibleState = visible;

      if (visible) {
        this.thirdPartyLinksHandler.hideForPurchaseBar();
      } else {
        this.thirdPartyLinksHandler.showForPurchaseBar();

        if (gorgiasChatButton && !this.isMobile) {
          GorgiasButtonHandler.adjustPositionDown(gorgiasChatButton, chatWindow);
        }
      }

      purchaseBarElements.forEach((element) => {
        element.classList.toggle(HIDDEN);
      });
    }
  };

  initializeEventListeners = () => {
    const debouncedHandler = debounce(DEBOUNCE_DELAY, this.handleScrollAndResize);

    document.addEventListener('scroll', debouncedHandler);
    document.addEventListener('resize', debouncedHandler);

    this.sideMenus.forEach((sideMenu) => sideMenu.initializeEventListeners());
    this.sideMenusMobile.forEach((sideMenu) => sideMenu.initializeEventListeners());
  };
}
